/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faMapLocationDot, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Chart } from 'react-google-charts';
// import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { Navbar } from '../components';
import { API_URL } from '../constants';
import '../styling/my-trips.scss';

function MyTrips() {
  const user = JSON.parse(localStorage.getItem('user'))?.name;
  const userEmail = JSON.parse(localStorage.getItem('user'))?.email;

  const [view, setView] = useState('upcoming');
  const [upcomingTrips, setUpcomingTrips] = useState([]);
  const [pastTrips, setPastTrips] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const navigate = useNavigate();

  const fetchTripsByEmail = async (email) => {
    const encodedEmail = encodeURIComponent(email);
    try {
      const response = await fetch(`${API_URL}/api/trips/fetch-by-email/${encodedEmail}`);
      console.log(response);
      if (!response.ok) {
        throw new Error('Failed to fetch trips');
      }
      const trips = await response.json();
      return trips;
    } catch (error) {
      console.error('Error fetching trips:', error);
      return [];
    }
  };

  const handleDeleteTrip = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/trips/${id}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        console.log('Trip deleted successfully');
        setUpcomingTrips((prevTrips) => prevTrips.filter((trip) => trip._id !== id)); // Update state
        setPastTrips((prevTrips) => prevTrips.filter((trip) => trip._id !== id));
      } else {
        console.error('Failed to delete trip');
      }
    } catch (error) {
      console.error('Error deleting trip:', error);
    }
  };

  // pop up to confirm delete
  const confirmDelete = (tripId) => {
    if (window.confirm('Are you sure you want to delete this trip?')) {
      handleDeleteTrip(tripId);
    }
  };

  const getCountryFromLabel = (label) => {
    const parts = label.split(','); // Split the string by commas
    return parts.length > 1 ? parts[parts.length - 1].trim() : ''; // Return the last part as country
  };

  useEffect(() => {
    if (userEmail) {
      const getTrips = async () => {
        const trips = await fetchTripsByEmail(userEmail);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const upcoming = [];
        const past = [];
        trips.forEach((trip) => {
          const tripStartDate = new Date(trip.userSelection.startDate);
          tripStartDate.setHours(0, 0, 0, 0); // Normalize to avoid time issues
          if (tripStartDate >= today) {
            upcoming.push(trip);
          } else {
            past.push(trip);
          }
        });
        setUpcomingTrips(upcoming);
        setPastTrips(past);
      };
      getTrips();
    } else {
      console.log('Please log in first');
    }
  }, [userEmail]);

  const renderTrips = (trips = []) => {
    const filteredTrips = trips.filter((trip) => trip.userSelection.location.label.toLowerCase().includes(searchQuery.toLowerCase()));
    return (
      <div className="trip-cards">
        {filteredTrips.map((trip) => (
          <div key={trip.id} className="trip-card">
            <h3>{trip.userSelection.location.label}</h3>
            <div className="trip-dates">
              {trip.userSelection.startDate && trip.userSelection.endDate
                ? `${new Date(trip.userSelection.startDate).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' })} - 
                  ${new Date(trip.userSelection.endDate).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' })}`
                : 'No date selected'}
            </div>
            <div className="trip-buttons">
              <button
                className="details-button"
                onClick={() => navigate(`/${trip._id}`)}
              >
                See More Details
              </button>
              <button
                className="delete-button"
                onClick={() => confirmDelete(trip._id)}
              >
                Delete Trip
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderMap = (trips) => {
    // Extract countries' names from trips and use them to highlight those countries
    const visitedCountries = [...new Set(trips.map((trip) => getCountryFromLabel(trip.userSelection.location.label)))];
    const data = [
      ['Country', 'Visited'],
      ...visitedCountries.map((country) => [country, 1]),
    ];

    const getTooltip = (country) => {
      return visitedCountries.includes(country) ? `${country} - Visited!` : country;
    };

    const updatedData = data.map((row) => [
      row[0],
      getTooltip(row[0]),
    ]);

    const regionColors = visitedCountries.reduce((acc, country) => {
      acc[country] = '#67A5C6'; // Set green color for visited countries
      return acc;
    }, {});

    return (
      <div className="map">
        <Chart
          chartType="GeoChart"
          width="100%"
          data={updatedData}
          options={{
            version: '51',
            tooltip: { trigger: 'focus', isHtml: true, textStyle: { fontSize: 14 } },
            legend: 'none',
            regions: regionColors,
          }}
        />
      </div>
    );
  };

  const renderView = () => {
    switch (view) {
      case 'upcoming':
        return (
          <>
            {/* Header */}
            <div className="header">
              <h1>My Upcoming Trips</h1>
              <div className="new-trip-button">
                <button onClick={() => navigate('/create-trip')}>
                  <FontAwesomeIcon icon={faPlus} /> New Trip
                </button>
              </div>
            </div>

            {/* Search and Sort */}
            <div className="search-sort">
              <input
                type="text"
                placeholder="Search Destination"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} // Update the search query
              />
              {/* <button>Sort By</button> */}
            </div>

            {/* Trips Section */}
            {renderTrips(upcomingTrips)}
          </>
        );

      case 'history':
        return (
          <>
            {/* Header */}
            <div className="header">
              <h1>My Travel History</h1>
            </div>

            {/* map */}
            <div className="map-card">
              {renderMap(pastTrips)}
            </div>

            <div className="header">
              <h1>My Past Trips</h1>
            </div>

            {/* Search and Sort */}
            <div className="search-sort">
              <input
                type="text"
                placeholder="Search Destination"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} // Update the search query
              />
              {/* <button>Sort By</button> */}
            </div>

            {/* Trips Section */}
            {renderTrips(pastTrips)}
          </>
        );
      default:
        return <div>No view selected</div>;
    }
  };

  return (
    <div className="my-trips-container">
      {/* Sidebar */}
      <div className="navbar" style={{ position: 'fixed', height: '100%', flex: '0 0 auto' }}>
        <Navbar />
      </div>

      {/* Main Content */}
      <div className="my-trips-content">
        {/* Toggle Bar */}
        <div className="toggle-bar">
          <div className="toggle-buttons">
            <button
              className={view === 'upcoming' ? 'active' : ''}
              onClick={() => setView('upcoming')}
            >
              Upcoming
            </button>
            <span className="divider">|</span>
            <button
              className={view === 'history' ? 'active' : ''}
              onClick={() => setView('history')}
            >
              History
            </button>
          </div>
        </div>

        {/* Rendered View */}
        <div className="rendered-view">
          {renderView()}
        </div>
      </div>
    </div>
  );
}

export default MyTrips;
